module.exports = __webpack_public_path__ + "media/images/front/varieties/SAFOR-b54b86dd18fac6fff540478a015abf9c.jpg";